export function getAccessTokenFromAppState() {
  return window.DocViewer.accessToken
}

export function getDocumentIdFromAppState() {
  return window.DocViewer.documentId
}
